export const admins = [
    'brandon.lasater.gt@gmail.com'
];

